import { useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import Cookies from 'universal-cookie';
import { saveLanguageLocally, getLanguagePath, performLanguageChange, LANGUAGES } from "helpers/util";

const cookies = new Cookies();

function LanguageSelect() {
    const navigate = useNavigate();
    const location = useLocation();
    const { i18n } = useTranslation();
    const auth = useSelector((store) => store.auth);
    const dropdownRef = useRef(null);

    const [dropdown, setDropdown] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // Инициализация языка из кук или браузера
    const initialLang = cookies.get('lang') ??
        ((navigator.languages && navigator.languages[0]) || navigator.language).slice(0, 2);

    // Основной обработчик смены языка
    const changeLanguageHandler = (l) => {
        performLanguageChange({
            lang: l,
            isAuth: !!auth,
            location: location,
            navigate: navigate,
            onStart: () => {
                setDropdown(false);
                setIsLoading(true);
            },
            onFinish: () => setIsLoading(false)
        });
    };

    // Закрытие дропдауна при клике вне области
    const handleClickOutside = useCallback((e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setDropdown(false);
        }
    }, []);

    useEffect(() => {
        // Проверка соответствия языка при загрузке
        const targetLang = LANGUAGES.includes(initialLang) ? initialLang : LANGUAGES[0];
        
        if (targetLang !== i18n.language) {
            saveLanguageLocally(targetLang);
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [initialLang, i18n.language, handleClickOutside]);


    return (
        <div ref={dropdownRef} className="header-lang head_menu-item text-sm-center w-sm-100 ml-0 ml-md-4 mt-3 mt-md-0">
            <button
                data-test-id="lang-btn"
                disabled={isLoading}
                onClick={() => setDropdown(!dropdown)}
                className="d-none d-md-flex btn-link text-medium text-white text-semibold"
                type="button"
            >
                {isLoading ? (
                    <Spin indicator={<LoadingOutlined style={{ color: '#fff' }} spin />} />
                ) : (
                    i18n.language.toUpperCase()
                )}
            </button>

            <div className={`sub_menu text-center flex-row flex-md-column justify-content-center mt-1 p-1 ${dropdown ? "d-flex" : "d-none"}`}>
                {i18n.options.languages?.map((l) => {
                    const newPath = getLanguagePath(l, location.pathname);
                    const isActive = i18n.language === l;

                    return (
                        <a
                            key={l}
                            data-test-id={"lang-" + l}
                            href={newPath}
                            onClick={(e) => {
                                e.preventDefault();
                                changeLanguageHandler(l);
                            }}
                            className={`justify-content-center text-white text-small text-sm-big text-semibold text-decoration-none px-2 pt-2 pt-md-0 ${isActive ? 'd-none' : 'd-block'}`}
                        >
                            {l.toUpperCase()}
                        </a>
                    );
                })}
            </div>
        </div>
    );
}

export default LanguageSelect;